export const ROOT_PATH = '/' as const;
export const APP_ROOT_PATH = '/app' as const;
export const HOME_PATH = `${APP_ROOT_PATH}` as const;
export const FIVE_HUNDRED_PATH = '/500' as const;
export const FOUR_ZERO_FOUR_PATH = '/404' as const;
export const LOGOUT_PATH = '/logout' as const;

// Shared UX
export const ACCOUNT_PATH = `${APP_ROOT_PATH}/account` as const;
export const ACCOUNT_PROFILE_PATH = `${ACCOUNT_PATH}/profile` as const;
export const NOTIFICATION_PREFERENCES_PATH = `${ACCOUNT_PATH}/notifications` as const;

// Public UX
export const ABOUT_US_PATH = '/about-us' as const;
export const ADD_PROPERTY_PATH = '/add-a-property' as const;
export const ANNUAL_REPORT_PATH = '/annual-report' as const;
export const AUTH_PATH = '/sign-in' as const;
export const BLOG_PATH = '/blog' as const;
export const BLOG_ARTICLE_PATH = `${BLOG_PATH}/:slug` as const;
export const CASE_STUDIES_PATH = '/case-studies' as const;
export const CASE_STUDY_PATH = `${CASE_STUDIES_PATH}/:slug` as const;
export const TECH_MANAGEMENT_PATH = '/tech-management' as const;
export const CLEANING_PATH = '/cleaning' as const;
export const RESTOCKING_PATH = '/restocking' as const;
export const PUBLIC_FURNITURE_PATH = '/furniture' as const;
export const AI_OFFICE_ASSISTANT_PATH = '/ai-office-assistant' as const;
export const VENDOR_NETWORK_PATH = '/vendor-network' as const;
export const CASE_STUDY_SLUGS_WITH_TITLES = [
  {
    slug: 'taskrabbit',
    title: 'TaskRabbit Case Study',
    description: 'How TaskRabbit outsourced in-person collaboration for 200 employees using Codi Offsites'
  }
] as { title: string; slug: string; description: string }[];
export const CASE_STUDY_PATHS = CASE_STUDY_SLUGS_WITH_TITLES.map(({ slug }) => `${CASE_STUDIES_PATH}/${slug}` as const);
export const CASE_STUDY_SLUGS = [] as string[];
export const CITY_PAGE_PATH = '/cities' as const;
export const CITY_PAGE_SLUG_PATH = `${CITY_PAGE_PATH}/:slug` as const;
export const COMMERCIAL_REAL_ESTATE_PATH = '/commercial-real-estate' as const;
export const COMPARE_PATH = '/compare' as const;
export const COMPARE_DETAIL_SLUG_PATH = `${COMPARE_PATH}/:slug` as const;
export const HOW_IT_WORKS_PATH = '/how-it-works' as const;
export const LISTING_PATH = '/office-space' as const;
export const LISTING_SLUG_PATH = `${LISTING_PATH}/:slug` as const;
export const LOCATION_PATH = '/locations' as const;
export const LOCATION_SLUG_PATH = `${LOCATION_PATH}/:country/:region/:city` as const;
export const NOTIFICATION_PREFERENCES_TOKEN_PATH = '/notification_preferences/:token' as const;
export const OFFICE_REQUEST_PATH = '/request-an-office' as const;
export const SERVICES_REQUEST_PATH = '/request-services' as const;
export const OFFSITES_PATH = '/offsites' as const;
export const PLAYBOOK_PATH = '/playbook' as const;
export const PRESS_PATH = '/press' as const;
export const PRIVACY_PATH = '/privacy' as const;
export const REFERRAL_LANDING_CODE_PATH = '/i/:referralCode' as const;
export const REFERRAL_LANDING_PATH = '/i' as const;
export const SEARCH_PATH = '/office-space/search' as const;
export const SEARCH_PATH_DEPRECATED = '/search' as const;
export const SEARCH_ENTRY_PATH = '/s/office-space' as const;
export const SITEMAP_PATH = '/sitemap' as const;
export const STB_REQUEST_PATH = '/request-booking' as const;
export const STB_REQUEST_SLUG_PATH = `${STB_REQUEST_PATH}/:id` as const;
export const TERMS_PATH = '/terms' as const;
export const SF_TECH_WEEK_PATH = '/sf-tech-week' as const;
export const NYC_TECH_WEEK_PATH = '/nyc-tech-week' as const;
export const TESTIMONIALS_PATH = '/testimonials' as const;
export const BROKERS_PATH = '/brokers' as const;
export const GFP_PATH = '/gfp' as const;
export const SLACK_INTEGRATION_INSTALLED_PATH = '/slack-integration-installed' as const;
export const SLACK_OAUTH_CALLBACK_PATH = '/slack/oauth/callback' as const;
export const SLACK_USER_OAUTH_CALLBACK_PATH = '/slack/user/oauth/callback' as const;

/** City-level service SEO landing pages (/services/:serviceSlug-:citySlug) */
export const OFFICE_SEO_SERVICES_CITY_PATH = '/services/:cityServiceSlug' as const;

/** Hub / landing pages for each city and neighborhood (/office-management-:locationSlug) */
export const OFFICE_SEO_HUB_PATH = '/office-management-:locationSlug' as const;

/** Comparison / decision-stage pages (/vs/:slug) */
export const OFFICE_SEO_COMPARISON_PATH = '/vs/:slug' as const;

/** Neighborhood + local service SEO landing pages (ENGINEERING_REQUIREMENTS.md) */
export const OFFICE_SEO_CLEANING_SF_PATH = '/san-francisco/:neighborhood/cleaning' as const;
export const OFFICE_SEO_CLEANING_NYC_PATH = '/new-york/:neighborhood/cleaning' as const;
export const OFFICE_SEO_PANTRY_SF_PATH = '/san-francisco/:neighborhood/pantry-restocking' as const;
export const OFFICE_SEO_PANTRY_NYC_PATH = '/new-york/:neighborhood/pantry-restocking' as const;
export const OFFICE_SEO_INTERNET_SF_PATH = '/san-francisco/:neighborhood/internet' as const;
export const OFFICE_SEO_INTERNET_NYC_PATH = '/new-york/:neighborhood/internet' as const;
export const OFFICE_SEO_ASSISTANT_SF_PATH = '/san-francisco/:neighborhood/office-assistant' as const;
export const OFFICE_SEO_ASSISTANT_NYC_PATH = '/new-york/:neighborhood/office-assistant' as const;
export const OFFICE_SEO_FURNITURE_SF_PATH = '/san-francisco/:neighborhood/office-furniture' as const;
export const OFFICE_SEO_FURNITURE_NYC_PATH = '/new-york/:neighborhood/office-furniture' as const;
export const OFFICE_SEO_DEEP_CLEANING_SF_PATH = '/san-francisco/:neighborhood/deep-cleaning' as const;
export const OFFICE_SEO_DEEP_CLEANING_NYC_PATH = '/new-york/:neighborhood/deep-cleaning' as const;
export const OFFICE_SEO_CARPET_CLEANING_SF_PATH = '/san-francisco/:neighborhood/carpet-cleaning' as const;
export const OFFICE_SEO_CARPET_CLEANING_NYC_PATH = '/new-york/:neighborhood/carpet-cleaning' as const;
export const OFFICE_SEO_WINDOW_CLEANING_SF_PATH = '/san-francisco/:neighborhood/window-cleaning' as const;
export const OFFICE_SEO_WINDOW_CLEANING_NYC_PATH = '/new-york/:neighborhood/window-cleaning' as const;
export const OFFICE_SEO_GLASS_CLEANING_SF_PATH = '/san-francisco/:neighborhood/glass-conference-room-cleaning' as const;
export const OFFICE_SEO_GLASS_CLEANING_NYC_PATH = '/new-york/:neighborhood/glass-conference-room-cleaning' as const;
export const OFFICE_SEO_WASTE_RECYCLING_SF_PATH = '/san-francisco/:neighborhood/waste-recycling' as const;
export const OFFICE_SEO_WASTE_RECYCLING_NYC_PATH = '/new-york/:neighborhood/waste-recycling' as const;
export const OFFICE_SEO_PANTRY_INVENTORY_SF_PATH = '/san-francisco/:neighborhood/pantry-inventory' as const;
export const OFFICE_SEO_PANTRY_INVENTORY_NYC_PATH = '/new-york/:neighborhood/pantry-inventory' as const;
export const OFFICE_SEO_COFFEE_SERVICE_SF_PATH = '/san-francisco/:neighborhood/coffee-service' as const;
export const OFFICE_SEO_COFFEE_SERVICE_NYC_PATH = '/new-york/:neighborhood/coffee-service' as const;
export const OFFICE_SEO_WATER_SERVICE_SF_PATH = '/san-francisco/:neighborhood/water-service' as const;
export const OFFICE_SEO_WATER_SERVICE_NYC_PATH = '/new-york/:neighborhood/water-service' as const;
export const OFFICE_SEO_TEAM_LUNCH_SF_PATH = '/san-francisco/:neighborhood/team-lunch' as const;
export const OFFICE_SEO_TEAM_LUNCH_NYC_PATH = '/new-york/:neighborhood/team-lunch' as const;
export const OFFICE_SEO_BREAKFAST_CATERING_SF_PATH = '/san-francisco/:neighborhood/breakfast-catering' as const;
export const OFFICE_SEO_BREAKFAST_CATERING_NYC_PATH = '/new-york/:neighborhood/breakfast-catering' as const;
export const OFFICE_SEO_INDIVIDUAL_MEALS_SF_PATH = '/san-francisco/:neighborhood/individual-meals' as const;
export const OFFICE_SEO_INDIVIDUAL_MEALS_NYC_PATH = '/new-york/:neighborhood/individual-meals' as const;
export const OFFICE_SEO_AD_HOC_CATERING_SF_PATH = '/san-francisco/:neighborhood/ad-hoc-catering' as const;
export const OFFICE_SEO_AD_HOC_CATERING_NYC_PATH = '/new-york/:neighborhood/ad-hoc-catering' as const;
export const OFFICE_SEO_HAPPY_HOUR_SF_PATH = '/san-francisco/:neighborhood/happy-hour' as const;
export const OFFICE_SEO_HAPPY_HOUR_NYC_PATH = '/new-york/:neighborhood/happy-hour' as const;
export const OFFICE_SEO_CONFERENCE_ROOM_AV_SF_PATH = '/san-francisco/:neighborhood/conference-room-av' as const;
export const OFFICE_SEO_CONFERENCE_ROOM_AV_NYC_PATH = '/new-york/:neighborhood/conference-room-av' as const;
export const OFFICE_SEO_NETWORK_INSTALLATION_SF_PATH = '/san-francisco/:neighborhood/network-installation' as const;
export const OFFICE_SEO_NETWORK_INSTALLATION_NYC_PATH = '/new-york/:neighborhood/network-installation' as const;
export const OFFICE_SEO_NETWORK_MANAGEMENT_SF_PATH = '/san-francisco/:neighborhood/network-management' as const;
export const OFFICE_SEO_NETWORK_MANAGEMENT_NYC_PATH = '/new-york/:neighborhood/network-management' as const;
export const OFFICE_SEO_CABLE_MANAGEMENT_SF_PATH = '/san-francisco/:neighborhood/cable-management' as const;
export const OFFICE_SEO_CABLE_MANAGEMENT_NYC_PATH = '/new-york/:neighborhood/cable-management' as const;
export const OFFICE_SEO_ROOM_BOOKING_SF_PATH = '/san-francisco/:neighborhood/room-booking' as const;
export const OFFICE_SEO_ROOM_BOOKING_NYC_PATH = '/new-york/:neighborhood/room-booking' as const;
export const OFFICE_SEO_PRINTING_SETUP_SF_PATH = '/san-francisco/:neighborhood/printing-setup' as const;
export const OFFICE_SEO_PRINTING_SETUP_NYC_PATH = '/new-york/:neighborhood/printing-setup' as const;
export const OFFICE_SEO_INTERIOR_DESIGN_SF_PATH = '/san-francisco/:neighborhood/interior-design' as const;
export const OFFICE_SEO_INTERIOR_DESIGN_NYC_PATH = '/new-york/:neighborhood/interior-design' as const;
export const OFFICE_SEO_OFFICE_MURALS_SF_PATH = '/san-francisco/:neighborhood/office-murals' as const;
export const OFFICE_SEO_OFFICE_MURALS_NYC_PATH = '/new-york/:neighborhood/office-murals' as const;
export const OFFICE_SEO_OFFICE_PAINTING_SF_PATH = '/san-francisco/:neighborhood/office-painting' as const;
export const OFFICE_SEO_OFFICE_PAINTING_NYC_PATH = '/new-york/:neighborhood/office-painting' as const;
export const OFFICE_SEO_GLASS_FROSTING_SF_PATH = '/san-francisco/:neighborhood/glass-frosting' as const;
export const OFFICE_SEO_GLASS_FROSTING_NYC_PATH = '/new-york/:neighborhood/glass-frosting' as const;
export const OFFICE_SEO_OFFICE_SIGNAGE_SF_PATH = '/san-francisco/:neighborhood/office-signage' as const;
export const OFFICE_SEO_OFFICE_SIGNAGE_NYC_PATH = '/new-york/:neighborhood/office-signage' as const;
export const OFFICE_SEO_CARE_ROOM_SF_PATH = '/san-francisco/:neighborhood/care-room' as const;
export const OFFICE_SEO_CARE_ROOM_NYC_PATH = '/new-york/:neighborhood/care-room' as const;
export const OFFICE_SEO_FURNITURE_ASSEMBLY_SF_PATH = '/san-francisco/:neighborhood/furniture-assembly' as const;
export const OFFICE_SEO_FURNITURE_ASSEMBLY_NYC_PATH = '/new-york/:neighborhood/furniture-assembly' as const;
export const OFFICE_SEO_LAYOUT_CHANGE_SF_PATH = '/san-francisco/:neighborhood/layout-change' as const;
export const OFFICE_SEO_LAYOUT_CHANGE_NYC_PATH = '/new-york/:neighborhood/layout-change' as const;
export const OFFICE_SEO_OFFICE_PLANTS_SF_PATH = '/san-francisco/:neighborhood/office-plants' as const;
export const OFFICE_SEO_OFFICE_PLANTS_NYC_PATH = '/new-york/:neighborhood/office-plants' as const;

// ─── Phase 4e: Security & Access ─────────────────────────────────────────────
export const OFFICE_SEO_KEYLESS_ACCESS_SF_PATH = '/san-francisco/:neighborhood/keyless-access' as const;
export const OFFICE_SEO_KEYLESS_ACCESS_NYC_PATH = '/new-york/:neighborhood/keyless-access' as const;
export const OFFICE_SEO_ALARM_SYSTEMS_SF_PATH = '/san-francisco/:neighborhood/alarm-systems' as const;
export const OFFICE_SEO_ALARM_SYSTEMS_NYC_PATH = '/new-york/:neighborhood/alarm-systems' as const;
export const OFFICE_SEO_SECURITY_CAMERAS_SF_PATH = '/san-francisco/:neighborhood/security-cameras' as const;
export const OFFICE_SEO_SECURITY_CAMERAS_NYC_PATH = '/new-york/:neighborhood/security-cameras' as const;
export const OFFICE_SEO_KEYPADS_SF_PATH = '/san-francisco/:neighborhood/keypads' as const;
export const OFFICE_SEO_KEYPADS_NYC_PATH = '/new-york/:neighborhood/keypads' as const;
export const OFFICE_SEO_LOCKBOXES_SF_PATH = '/san-francisco/:neighborhood/lockboxes' as const;
export const OFFICE_SEO_LOCKBOXES_NYC_PATH = '/new-york/:neighborhood/lockboxes' as const;
export const OFFICE_SEO_VISITOR_MANAGEMENT_SF_PATH = '/san-francisco/:neighborhood/visitor-management' as const;
export const OFFICE_SEO_VISITOR_MANAGEMENT_NYC_PATH = '/new-york/:neighborhood/visitor-management' as const;
export const OFFICE_SEO_BUSINESS_INSURANCE_SF_PATH = '/san-francisco/:neighborhood/business-insurance' as const;
export const OFFICE_SEO_BUSINESS_INSURANCE_NYC_PATH = '/new-york/:neighborhood/business-insurance' as const;

// ─── Phase 4f: Facilities & Maintenance ──────────────────────────────────────
export const OFFICE_SEO_ELECTRICAL_SERVICES_SF_PATH = '/san-francisco/:neighborhood/electrical-services' as const;
export const OFFICE_SEO_ELECTRICAL_SERVICES_NYC_PATH = '/new-york/:neighborhood/electrical-services' as const;
export const OFFICE_SEO_HVAC_SF_PATH = '/san-francisco/:neighborhood/hvac' as const;
export const OFFICE_SEO_HVAC_NYC_PATH = '/new-york/:neighborhood/hvac' as const;
export const OFFICE_SEO_PLUMBING_SF_PATH = '/san-francisco/:neighborhood/plumbing' as const;
export const OFFICE_SEO_PLUMBING_NYC_PATH = '/new-york/:neighborhood/plumbing' as const;
export const OFFICE_SEO_PEST_CONTROL_SF_PATH = '/san-francisco/:neighborhood/pest-control' as const;
export const OFFICE_SEO_PEST_CONTROL_NYC_PATH = '/new-york/:neighborhood/pest-control' as const;
export const OFFICE_SEO_OFFICE_MOVING_SF_PATH = '/san-francisco/:neighborhood/office-moving' as const;
export const OFFICE_SEO_OFFICE_MOVING_NYC_PATH = '/new-york/:neighborhood/office-moving' as const;
export const OFFICE_SEO_MOUNTING_INSTALLATION_SF_PATH = '/san-francisco/:neighborhood/mounting-installation' as const;
export const OFFICE_SEO_MOUNTING_INSTALLATION_NYC_PATH = '/new-york/:neighborhood/mounting-installation' as const;

// Admin UX
export const ADMIN_PATH = '/admin' as const;
export const ADMIN_AI_ASSISTANT_PATH = `${ADMIN_PATH}/ai-assistant` as const;
export const ADMIN_AI_ASSISTANT_DASHBOARD_PATH = `${ADMIN_AI_ASSISTANT_PATH}/dashboard` as const;
export const ADMIN_AI_ASSISTANT_CONVERSATIONS_LIST_PATH = `${ADMIN_AI_ASSISTANT_PATH}/conversations` as const;
export const ADMIN_AI_ASSISTANT_LEARNINGS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/learnings` as const;
export const ADMIN_AI_ASSISTANT_CONVERSATION_PATH = `${ADMIN_AI_ASSISTANT_PATH}/conversations/:id` as const;
export const ADMIN_AI_ASSISTANT_CONVERSATION_MESSAGES_PATH =
  `${ADMIN_AI_ASSISTANT_PATH}/conversations/:id/messages` as const;
export const ADMIN_AI_ASSISTANT_CONVERSATION_ANALYSIS_PATH =
  `${ADMIN_AI_ASSISTANT_PATH}/conversations/:id/analysis` as const;
export const ADMIN_AI_ASSISTANT_INTENTS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/intents` as const;
export const ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/intent-tests` as const;
export const ADMIN_AI_ASSISTANT_LLM_TESTS_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/llm` as const;
export const ADMIN_AI_ASSISTANT_INTENT_BATTERY_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/battery` as const;
export const ADMIN_AI_ASSISTANT_INTENT_PROMPTS_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/prompts` as const;
export const ADMIN_AI_ASSISTANT_INTENT_IMPROVE_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/improve` as const;
export const ADMIN_AI_ASSISTANT_INTENT_COMPARE_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/compare` as const;
export const ADMIN_AI_ASSISTANT_INTENT_CONFIGS_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/configs` as const;
export const ADMIN_AI_ASSISTANT_INTENT_SWEEPS_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/sweeps` as const;
export const ADMIN_AI_ASSISTANT_INTENT_SWEEP_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/sweeps/:sweepId` as const;
export const ADMIN_AI_ASSISTANT_INTENT_TEST_RUN_PATH = `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/runs/:runId` as const;
export const ADMIN_AI_ASSISTANT_INTENT_TEST_RESULT_IMPROVE_PATH =
  `${ADMIN_AI_ASSISTANT_INTENT_TESTS_PATH}/runs/:runId/improve/:resultId` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOWS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOW_NEW_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows/new` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOW_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows/:id` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOW_STEPS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows/:id/steps` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOW_VENDORS_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows/:id/vendors` as const;
export const ADMIN_AI_ASSISTANT_WORKFLOW_EDIT_PATH = `${ADMIN_AI_ASSISTANT_PATH}/workflows/:id/edit` as const;
export const ADMIN_CUSTOMER_PATH = `${ADMIN_PATH}/customers/:customerId` as const;
export const ADMIN_CUSTOMER_PLAN_PATH = `${ADMIN_PATH}/customers/:customerId/plans/:planId` as const;
export const ADMIN_CUSTOMER_TENANCIES_PATH = `${ADMIN_PATH}/customers/:customerId/tenancies` as const;
export const ADMIN_CUSTOMER_TENANCY_PATH = `${ADMIN_CUSTOMER_TENANCIES_PATH}/:tenancyId` as const;
export const ADMIN_CUSTOMER_TENANCY_VENDOR_ACCESS_PATH = `${ADMIN_CUSTOMER_TENANCY_PATH}/vendor-access` as const;
export const ADMIN_CUSTOMER_TENANCY_VENDOR_ACCESS_INSTRUCTIONS_PATH =
  `${ADMIN_CUSTOMER_TENANCY_VENDOR_ACCESS_PATH}/:accessPathId` as const;
export const ADMIN_CUSTOMER_TENANCY_VENDOR_ACCESS_PREVIEW_PATH =
  `${ADMIN_CUSTOMER_TENANCY_VENDOR_ACCESS_INSTRUCTIONS_PATH}/preview` as const;
export const ADMIN_CUSTOMERS_PATH = `${ADMIN_PATH}/customers` as const;
export const ADMIN_TOOLS_PATH = `${ADMIN_PATH}/tools` as const;
export const ADMIN_DEVELOPER_TOOLS_PATH = `${ADMIN_TOOLS_PATH}/developer-tools` as const;
export const ADMIN_DOCUMENT_TYPE_PATH = `${ADMIN_TOOLS_PATH}/documents/:typeId` as const;
export const ADMIN_DOCUMENT_TYPES_PATH = `${ADMIN_TOOLS_PATH}/documents` as const;
export const ADMIN_FEATURES_PATH = `${ADMIN_TOOLS_PATH}/features` as const;
export const ADMIN_SLOP_SHOP_DATA_PATH = `${ADMIN_TOOLS_PATH}/slop-shop-data` as const;
export const ADMIN_MARKET_CONFIG_PATH = `${ADMIN_TOOLS_PATH}/market-config` as const;
export const ADMIN_OLD_PRODUCTS_PATH = `${ADMIN_TOOLS_PATH}/products-old` as const;
export const ADMIN_OLD_PRODUCT_SLUG_PATH = `${ADMIN_OLD_PRODUCTS_PATH}/:id` as const;
export const ADMIN_PRODUCTS_PATH = `${ADMIN_PATH}/products` as const;
export const ADMIN_MAP_PATH = `${ADMIN_PATH}/map` as const;
export const ADMIN_MORE_PATH = `${ADMIN_PATH}/more` as const;
export const ADMIN_PAYOUTS_DRY_RUN_PATH = `${ADMIN_TOOLS_PATH}/dry-run` as const;
export const ADMIN_PAYOUTS_PATH = `${ADMIN_PATH}/payouts` as const;
export const ADMIN_PAYOUT_JOBS_PATH = `${ADMIN_PATH}/payouts/jobs` as const;
export const ADMIN_PAYOUT_JOB_PATH = `${ADMIN_PATH}/payouts/jobs/:payoutJobId` as const;
export const ADMIN_PAYOUT_PATH = `${ADMIN_PATH}/payouts/:payoutId` as const;
export const ADMIN_CONSUMABLES_PATH = `${ADMIN_PATH}/consumables` as const;
export const ADMIN_CONSUMABLES_ORDERS_PATH = `${ADMIN_CONSUMABLES_PATH}/orders` as const;
export const ADMIN_CONSUMABLES_ORDER_PATH = `${ADMIN_CONSUMABLES_ORDERS_PATH}/:consumablesOrderId` as const;
export const ADMIN_CONSUMABLES_PAYMENTS_PATH = `${ADMIN_CONSUMABLES_PATH}/payments` as const;
export const ADMIN_CONSUMABLES_PAYMENT_SLUG_PATH = `${ADMIN_CONSUMABLES_PAYMENTS_PATH}/:consumablesPaymentId` as const;
export const ADMIN_TASKS_PATH = `${ADMIN_PATH}/tasks` as const;
export const ADMIN_SEARCH_ENTRIES_PATH = `${ADMIN_TOOLS_PATH}/search-entries` as const;
export const ADMIN_SEARCH_ENTRIES_SLUG_PATH = `${ADMIN_TOOLS_PATH}/search-entries/:guid` as const;
export const ADMIN_SEO_PATH = `${ADMIN_TOOLS_PATH}/seo` as const;
export const ADMIN_SHORT_TERM_BOOKINGS_PATH = `${ADMIN_PATH}/short-term-bookings` as const;
export const ADMIN_SHORT_TERM_BOOKING_SLUG_PATH = `${ADMIN_PATH}/short-term-bookings/:id` as const;
export const ADMIN_USER_PATH = `${ADMIN_PATH}/users/:id` as const;
export const ADMIN_USERS_PATH = `${ADMIN_PATH}/users` as const;
export const ADMIN_SUPPORT_PATH = `${ADMIN_PATH}/support` as const;
export const ADMIN_SUPPORT_NOTIFICATIONS_PATH = `${ADMIN_SUPPORT_PATH}/notifications` as const;
export const ADMIN_SUPPORT_TICKET_PATH = `${ADMIN_SUPPORT_PATH}/:id` as const;
export const ADMIN_SUPPORT_EMPLOYEE_REQUEST_PATH = `${ADMIN_SUPPORT_PATH}/employee-requests/:id` as const;
export const ADMIN_SUPPORT_SLACK_INSTALLATIONS_PATH = `${ADMIN_SUPPORT_PATH}/slack-installations` as const;
export const ADMIN_SUPPORT_SLACK_INSTALLATION_PATH = `${ADMIN_SUPPORT_PATH}/slack-installations/:id` as const;
export const ADMIN_WORKSPACE_PATH = `${ADMIN_PATH}/workspaces/:workspaceId` as const;
export const ADMIN_WORKSPACES_PATH = `${ADMIN_PATH}/workspaces` as const;
export const ADMIN_BUILDING_PATH = `${ADMIN_PATH}/buildings/:buildingId` as const;
export const ADMIN_BUILDINGS_PATH = `${ADMIN_PATH}/buildings` as const;
export const ADMIN_BUILDING_UNIT_PATH = `${ADMIN_BUILDINGS_PATH}/:buildingId/units/:buildingUnitId` as const;
export const ADMIN_WORKSPACE_USER_PATH = `${ADMIN_TOOLS_PATH}/workspace_users/:licensorId` as const; // TODO: rename
export const ADMIN_LICENSORS_PATH = `${ADMIN_PATH}/licensors` as const;
export const ADMIN_LICENSOR_PATH = `${ADMIN_PATH}/licensors/:licensorId` as const;
export const ADMIN_LICENSOR_PAYOUT_ACCOUNT_PATH = `${ADMIN_PATH}/licensors/:licensorId/payout_account` as const;
export const ADMIN_LANDLORDS_PATH = `${ADMIN_PATH}/landlords` as const;
export const ADMIN_LANDLORDS_PAYOUTS_PATH = `${ADMIN_LANDLORDS_PATH}/payouts` as const;
export const ADMIN_LANDLORD_SLUG_PATH = `${ADMIN_LANDLORDS_PATH}/:landlordId` as const;
export const ADMIN_LOCATIONS_PATH = `${ADMIN_TOOLS_PATH}/locations` as const;
export const ADMIN_ROUND_ROBIN_GROUPS_PATH = `${ADMIN_TOOLS_PATH}/round-robin` as const;
export const ADMIN_REFERRAL_CONFIGS_PATH = `${ADMIN_TOOLS_PATH}/referral-configs` as const;
export const ADMIN_INCLUDED_SERVICES_PATH = `${ADMIN_TOOLS_PATH}/included-services` as const;
export const ADMIN_PRICING_PATH = `${ADMIN_TOOLS_PATH}/pricing` as const;
export const ADMIN_CLIENT_DIGEST_PATH = `${ADMIN_SUPPORT_PATH}/client-digests` as const;
export const ADMIN_CLIENT_DIGEST_DRAFT_PATH = `${ADMIN_CLIENT_DIGEST_PATH}/:draftId` as const;
export const ADMIN_CLIENT_DIGEST_OEMS_PATH = `${ADMIN_CLIENT_DIGEST_PATH}/oems` as const;
export const ADMIN_CLIENT_DIGEST_PRESETS_PATH = `${ADMIN_CLIENT_DIGEST_PATH}/presets` as const;
export const ADMIN_LEASES_PATH = `${ADMIN_TOOLS_PATH}/leases` as const;
export const ADMIN_VENDORS_PATH = `${ADMIN_PATH}/vendors` as const;
export const ADMIN_VENDORS_ALL_PATH = `${ADMIN_VENDORS_PATH}/all` as const;
export const ADMIN_VENDORS_PAYMENTS_PATH = `${ADMIN_VENDORS_PATH}/payments` as const;
export const ADMIN_VENDOR_PATH = `${ADMIN_VENDORS_PATH}/:vendorId` as const;

export const QA_LINK = '/qa-link' as const;

// Licensor UX
export const PROPERTIES_PATH = `${APP_ROOT_PATH}/properties` as const;
export const PROPERTIES_LISTINGS_PATH = `${PROPERTIES_PATH}/listings` as const;
export const PROPERTIES_LISTING_SLUG_PATH = `${PROPERTIES_LISTINGS_PATH}/:workspaceId` as const;
export const PROPERTIES_ACCOUNTS_PATH = `${PROPERTIES_PATH}/accounts` as const;
export const PROPERTIES_PAYOUTS_PATH = `${PROPERTIES_PATH}/payouts` as const;
export const PROPERTIES_PAYOUT_SUMMARY_PATH = `${PROPERTIES_PAYOUTS_PATH}/:payoutId` as const;

// Plans Customer UX
export const DASHBOARD_PATH = `${APP_ROOT_PATH}/dashboard` as const;
export const AGREEMENTS_PATH = `${DASHBOARD_PATH}/agreements` as const;
export const AGREEMENTS_SLUG_PATH = `${DASHBOARD_PATH}/agreements/:planId` as const;
export const CUSTOMER_REQUESTS_PATH = `${APP_ROOT_PATH}/requests` as const;
export const CUSTOMER_OFFICE_REQUESTS_PATH = `${CUSTOMER_REQUESTS_PATH}/offices` as const;
export const CUSTOMER_OFFICE_REQUESTS_SLUG_PATH = `${CUSTOMER_OFFICE_REQUESTS_PATH}/:workspaceId` as const;
export const CUSTOMER_REQUESTS_SLUG_PATH = `${CUSTOMER_REQUESTS_PATH}/:id` as const;
export const OFFICES_PATH = `${APP_ROOT_PATH}/offices` as const;
export const OFFICES_SLUG_PATH = `${OFFICES_PATH}/:workspaceId` as const;
export const PAYMENTS_PATH = `${APP_ROOT_PATH}/payments` as const;
export const PAYMENT_SUMMARY_SLUG_PATH = `${PAYMENTS_PATH}/:stripeInvoiceId` as const;
export const CUSTOMER_OFFICE_REQUEST_PATH = `${APP_ROOT_PATH}/offices/requests` as const;
export const CUSTOMER_OFFICE_REQUEST_ID_PATH = `${CUSTOMER_OFFICE_REQUEST_PATH}/:id` as const;
export const UPCOMING_PAYMENT_PATH = `${DASHBOARD_PATH}/upcoming` as const;
export const REFERRALS_PATH = `${APP_ROOT_PATH}/referrals` as const;

export const CUSTOMER_OFFSITES_PATH = `${APP_ROOT_PATH}/offsites` as const;
export const CUSTOMER_OFFSITES_SLUG_PATH = `${CUSTOMER_OFFSITES_PATH}/:id` as const;
export const CUSTOMER_SERVICES_PATH = `${APP_ROOT_PATH}/services` as const;
export const CUSTOMER_CLEANING_SLUG_PATH = `${CUSTOMER_SERVICES_PATH}/:workspaceId/cleaning` as const;
export const CUSTOMER_CLEANING_REDIRECT_PATH = `${CUSTOMER_SERVICES_PATH}/cleaning` as const;
export const CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH = `${CUSTOMER_SERVICES_PATH}/:workspaceId` as const;
export const CUSTOMER_FURNITURE_SLUG_PATH = `${CUSTOMER_SERVICES_PATH}/:workspaceId/furniture` as const;
export const MEMBERSHIP_PATH = `${APP_ROOT_PATH}/membership` as const;
export const MEMBERSHIP_PLAN_PATH = `${MEMBERSHIP_PATH}/plan` as const;
export const MEMBERSHIP_PLAN_SLUG_PATH = `${MEMBERSHIP_PLAN_PATH}/:planId` as const;
export const MEMBERSHIP_ADD_ONS_SLUG_PATH = `${MEMBERSHIP_PLAN_SLUG_PATH}/add-ons` as const;
export const ADD_ON_ORDERS_REDIRECT_PATH = `${APP_ROOT_PATH}/orders` as const;
export const ADD_ON_ORDERS_REDIRECT_SLUG_PATH = `${ADD_ON_ORDERS_REDIRECT_PATH}/:id` as const;
export const CUSTOMER_ORDERS_PATH = `${CUSTOMER_SERVICES_PATH}/:workspaceId/orders` as const;
export const CUSTOMER_ADD_FURNITURE_SLUG_PATH = `${CUSTOMER_SERVICES_PATH}/:workspaceId/furniture/add` as const;
export const CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH =
  `${CUSTOMER_SERVICES_PATH}/:workspaceId/cleaning-schedule/edit` as const;

// Tenant UX
export const AI_ASSISTANT_PATH = `${APP_ROOT_PATH}/conversations` as const;
export const AI_ASSISTANT_SLUG_PATH = `${AI_ASSISTANT_PATH}/:id` as const;
export const TENANT_PAYMENT_METHODS_PATH = `${APP_ROOT_PATH}/payment-methods` as const;
export const PANTRY_PATH = `${APP_ROOT_PATH}/pantry` as const;
export const SMART_PANTRY_PATH = `${APP_ROOT_PATH}/smart-pantry` as const;
export const PANTRY_SHOP_PATH = `${PANTRY_PATH}/shop` as const;
export const PANTRY_SUBSCRIPTION_PATH = `${PANTRY_PATH}/subscription` as const;
export const PANTRY_ORDERS_PATH = `${PANTRY_PATH}/orders` as const;
export const TENANT_ONBOARDING_CHECKLIST_PATH = `${APP_ROOT_PATH}/onboarding-checklist` as const;
export const CLEANING_SERVICE_PATH = `${APP_ROOT_PATH}/cleaning-service` as const;
export const CLEANING_SERVICE_SET_UP_PATH = `${CLEANING_SERVICE_PATH}/set-up` as const;
export const CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH = `${CLEANING_SERVICE_PATH}/checkout` as const;
export const TENANT_EMPLOYEE_COMING_SOON_PATH = `${APP_ROOT_PATH}/coming-soon` as const;
export const PANTRY_ORDER_SLUG_PATH = `${PANTRY_ORDERS_PATH}/:id` as const;
export const PANTRY_SUBSCRIPTION_EDIT_PATH = `${PANTRY_SUBSCRIPTION_PATH}/edit` as const;
export const CONSUMABLES_CHECKOUT_PATH = `${PANTRY_PATH}/checkout` as const;
export const CONSUMABLES_ONBOARDING_SET_PATH = `${PANTRY_PATH}/onboarding/set` as const;
export const FURNITURE_PATH = `${APP_ROOT_PATH}/furniture` as const;
export const FURNITURE_INVENTORY_PATH = `${FURNITURE_PATH}/inventory` as const;
export const FURNITURE_SHOP_PATH = `${FURNITURE_PATH}/shop` as const;
export const FURNITURE_ORDERS_PATH = `${FURNITURE_PATH}/orders` as const;
export const FURNITURE_CHECKOUT_PATH = `${FURNITURE_PATH}/checkout` as const;
export const FURNITURE_GET_STARTED_PATH = `${FURNITURE_PATH}/get-started` as const;
export const FURNITURE_SHOP_PRODUCT_SET_PATH = `${FURNITURE_SHOP_PATH}/products` as const;
export const FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH = `${FURNITURE_SHOP_PRODUCT_SET_PATH}/:baseProductSetId` as const;
export const SERVICE_CATEGORIES_PATH = `${APP_ROOT_PATH}/service-categories` as const;
export const SERVICES_CLEANING_PATH = `${SERVICE_CATEGORIES_PATH}/cleaning` as const;
export const SERVICES_DESIGN_PATH = `${SERVICE_CATEGORIES_PATH}/design` as const;
export const SERVICES_IT_PATH = `${SERVICE_CATEGORIES_PATH}/it` as const;
export const SERVICES_MAINTENANCE_PATH = `${SERVICE_CATEGORIES_PATH}/maintenance` as const;
export const SERVICES_CATERING_EVENTS_PATH = `${SERVICE_CATEGORIES_PATH}/catering-events` as const;
export const SERVICES_SECURITY_ACCESS_PATH = `${SERVICE_CATEGORIES_PATH}/security-access` as const;
export const TENANT_ADMIN_PATH = `${APP_ROOT_PATH}/admin` as const;
export const TENANT_ADMIN_PAYMENTS_PATH = `${TENANT_ADMIN_PATH}/payments` as const;
export const TENANT_ADMIN_SUMMARIES_PATH = `${TENANT_ADMIN_PATH}/summaries` as const;
export const TENANT_ADMIN_SUMMARY_DETAIL_PATH = `${TENANT_ADMIN_SUMMARIES_PATH}/:yearMonth` as const;
export const TENANT_ADMIN_BILLING_PATH = `${TENANT_ADMIN_PATH}/billling` as const;
export const TENANT_ADMIN_PAYMENT_METHODS_PATH = `${TENANT_ADMIN_PATH}/payment-methods` as const;
export const TENANT_ADMIN_TEAM_PATH = `${TENANT_ADMIN_PATH}/team` as const;
export const TENANT_ADMIN_INTEGRATIONS_PATH = `${TENANT_ADMIN_PATH}/integrations` as const;
export const TENANT_ADMIN_COMPANY_PATH = `${TENANT_ADMIN_PATH}/company` as const;
export const TENANT_ADMIN_PLATFORM_FEE_PROPOSALS_PATH = `${TENANT_ADMIN_PATH}/proposals` as const;
export const TENANT_ADMIN_PLATFORM_FEE_PROPOSAL_SLUG_PATH = `${TENANT_ADMIN_PLATFORM_FEE_PROPOSALS_PATH}/:id` as const;
export const TENANT_ADMIN_BUILDINGS_PATH = `${TENANT_ADMIN_PATH}/buildings` as const;
export const TENANT_ADMIN_BUILDING_PATH = `${TENANT_ADMIN_BUILDINGS_PATH}/:buildingId` as const;
export const TENANT_ADMIN_BUILDING_TAB_PATH = `${TENANT_ADMIN_BUILDING_PATH}/:tab` as const;
export const TENANT_ADMIN_BUILDING_ACCESS_PATH_INSTRUCTIONS_PATH =
  `${TENANT_ADMIN_BUILDING_PATH}/access/:accessPathId` as const;
export const TENANT_ADMIN_BUILDING_ACCESS_PATH_PREVIEW_PATH =
  `${TENANT_ADMIN_BUILDING_ACCESS_PATH_INSTRUCTIONS_PATH}/preview` as const;
export const TENANT_ADMIN_MOBILE_SUBSCRIPTION_DETAILS_PATH =
  `${TENANT_ADMIN_PATH}/mobile-subscription-details` as const;
export const TENANT_ADMIN_BUILDING_INTERNET_PLANS_PATH = `${TENANT_ADMIN_BUILDING_PATH}/internet/plans` as const;
export const TENANT_ADMIN_BUILDING_INTERNET_PLANS_CHECKOUT_PATH =
  `${TENANT_ADMIN_BUILDING_INTERNET_PLANS_PATH}/checkout` as const;
// Shared Plans/Tenant UX
export const CUSTOMER_SUPPORT_PATH = `${APP_ROOT_PATH}/requests` as const;
export const CUSTOMER_SUPPORT_SLUG_PATH = `${CUSTOMER_SUPPORT_PATH}/:id` as const;
export const CUSTOMER_SUPPORT_SLUG_MESSAGES_PATH = `${CUSTOMER_SUPPORT_SLUG_PATH}/messages` as const;
export const CUSTOMER_SUPPORT_SLUG_DETAILS_PATH = `${CUSTOMER_SUPPORT_SLUG_PATH}/details` as const;
export const CUSTOMER_SUPPORT_WORK_ORDER_SLUG_PATH = `${CUSTOMER_SUPPORT_SLUG_PATH}/orders/:id` as const;
export const EMPLOYEE_REQUESTS_PATH = `${APP_ROOT_PATH}/employee-requests` as const;
export const EMPLOYEE_REQUESTS_SLUG_PATH = `${EMPLOYEE_REQUESTS_PATH}/:id` as const;

// Vendor UX
export const VENDOR_PATH = `${APP_ROOT_PATH}/vendor` as const;
export const VENDOR_TEAM_PATH = `${VENDOR_PATH}/team` as const;
export const VENDOR_TASKS_PATH = `${VENDOR_PATH}/tasks` as const;
export const VENDOR_TASK_SCHEDULES_PATH = `${VENDOR_PATH}/schedules` as const;

// Landlord UX
export const LANDLORD_PATH = `${APP_ROOT_PATH}/landlord` as const;
export const LANDLORD_DASHBOARD_PATH = `${LANDLORD_PATH}/dashboard` as const;
export const LANDLORD_PAYMENTS_PATH = `${LANDLORD_PATH}/payments` as const;

export const PATHS = [
  ...CASE_STUDY_PATHS,
  ABOUT_US_PATH,
  ACCOUNT_PATH,
  ADD_ON_ORDERS_REDIRECT_PATH,
  ADD_ON_ORDERS_REDIRECT_SLUG_PATH,
  CONSUMABLES_CHECKOUT_PATH,
  ADD_PROPERTY_PATH,
  ADMIN_PATH,
  ADMIN_CONSUMABLES_PATH,
  ADMIN_AI_ASSISTANT_PATH,
  ADMIN_AI_ASSISTANT_DASHBOARD_PATH,
  ADMIN_AI_ASSISTANT_CONVERSATIONS_LIST_PATH,
  ADMIN_AI_ASSISTANT_LEARNINGS_PATH,
  ADMIN_AI_ASSISTANT_CONVERSATION_PATH,
  ADMIN_AI_ASSISTANT_CONVERSATION_MESSAGES_PATH,
  ADMIN_AI_ASSISTANT_CONVERSATION_ANALYSIS_PATH,
  ADMIN_AI_ASSISTANT_INTENTS_PATH,
  ADMIN_SUPPORT_PATH,
  ADMIN_SUPPORT_NOTIFICATIONS_PATH,
  ADMIN_SUPPORT_TICKET_PATH,
  ADMIN_SUPPORT_EMPLOYEE_REQUEST_PATH,
  ADMIN_SUPPORT_SLACK_INSTALLATIONS_PATH,
  ADMIN_SUPPORT_SLACK_INSTALLATION_PATH,
  AGREEMENTS_PATH,
  AGREEMENTS_SLUG_PATH,
  AI_ASSISTANT_PATH,
  AI_ASSISTANT_SLUG_PATH,
  ANNUAL_REPORT_PATH,
  AUTH_PATH,
  BLOG_ARTICLE_PATH,
  BLOG_PATH,
  BROKERS_PATH,
  CASE_STUDY_PATH,
  CITY_PAGE_SLUG_PATH,
  COMMERCIAL_REAL_ESTATE_PATH,
  COMPARE_DETAIL_SLUG_PATH,
  COMPARE_PATH,
  VENDOR_TASKS_PATH,
  VENDOR_TASK_SCHEDULES_PATH,
  CLEANING_SERVICE_PATH,
  CLEANING_SERVICE_SET_UP_PATH,
  CLEANING_SERVICE_ONBOARDING_CHECKOUT_PATH,
  CONSUMABLES_ONBOARDING_SET_PATH,
  CUSTOMER_ADD_FURNITURE_SLUG_PATH,
  CUSTOMER_CLEANING_REDIRECT_PATH,
  CUSTOMER_CLEANING_SLUG_PATH,
  CUSTOMER_EDIT_CLEANING_SCHEDULE_PATH,
  CUSTOMER_FURNITURE_SLUG_PATH,
  CUSTOMER_OFFICE_REQUEST_ID_PATH,
  CUSTOMER_OFFICE_REQUEST_PATH,
  CUSTOMER_OFFICE_REQUESTS_SLUG_PATH,
  CUSTOMER_OFFSITES_PATH,
  CUSTOMER_OFFSITES_SLUG_PATH,
  CUSTOMER_ORDERS_PATH,
  CUSTOMER_REQUESTS_PATH,
  CUSTOMER_REQUESTS_SLUG_PATH,
  CUSTOMER_SERVICES_AND_AMENITIES_SLUG_PATH,
  CUSTOMER_SUPPORT_PATH,
  CUSTOMER_SUPPORT_SLUG_PATH,
  CUSTOMER_SUPPORT_SLUG_MESSAGES_PATH,
  CUSTOMER_SUPPORT_SLUG_DETAILS_PATH,
  CUSTOMER_SUPPORT_WORK_ORDER_SLUG_PATH,
  EMPLOYEE_REQUESTS_PATH,
  EMPLOYEE_REQUESTS_SLUG_PATH,
  DASHBOARD_PATH,
  FIVE_HUNDRED_PATH,
  FOUR_ZERO_FOUR_PATH,
  FURNITURE_CHECKOUT_PATH,
  FURNITURE_GET_STARTED_PATH,
  FURNITURE_PATH,
  FURNITURE_INVENTORY_PATH,
  FURNITURE_ORDERS_PATH,
  FURNITURE_SHOP_PATH,
  FURNITURE_SHOP_PRODUCT_SET_SLUG_PATH,
  SERVICE_CATEGORIES_PATH,
  SERVICES_CLEANING_PATH,
  SERVICES_DESIGN_PATH,
  SERVICES_IT_PATH,
  SERVICES_MAINTENANCE_PATH,
  SERVICES_CATERING_EVENTS_PATH,
  SERVICES_SECURITY_ACCESS_PATH,
  HOME_PATH,
  HOW_IT_WORKS_PATH,
  LISTING_PATH,
  LISTING_SLUG_PATH,
  LOCATION_SLUG_PATH,
  LOGOUT_PATH,
  MEMBERSHIP_ADD_ONS_SLUG_PATH,
  MEMBERSHIP_PATH,
  MEMBERSHIP_PLAN_PATH,
  MEMBERSHIP_PLAN_SLUG_PATH,
  NOTIFICATION_PREFERENCES_TOKEN_PATH,
  NYC_TECH_WEEK_PATH,
  OFFICE_REQUEST_PATH,
  OFFICES_PATH,
  OFFICES_SLUG_PATH,
  OFFSITES_PATH,
  PANTRY_PATH,
  SMART_PANTRY_PATH,
  PANTRY_ORDERS_PATH,
  PANTRY_ORDER_SLUG_PATH,
  PANTRY_SHOP_PATH,
  PANTRY_SUBSCRIPTION_EDIT_PATH,
  PANTRY_SUBSCRIPTION_PATH,
  PAYMENT_SUMMARY_SLUG_PATH,
  PAYMENTS_PATH,
  PLAYBOOK_PATH,
  PRESS_PATH,
  PRIVACY_PATH,
  PROPERTIES_ACCOUNTS_PATH,
  PROPERTIES_LISTING_SLUG_PATH,
  PROPERTIES_LISTINGS_PATH,
  PROPERTIES_PATH,
  PROPERTIES_PAYOUT_SUMMARY_PATH,
  PROPERTIES_PAYOUTS_PATH,
  QA_LINK,
  REFERRAL_LANDING_CODE_PATH,
  REFERRAL_LANDING_PATH,
  REFERRALS_PATH,
  ROOT_PATH,
  SEARCH_ENTRY_PATH,
  SEARCH_PATH_DEPRECATED,
  SEARCH_PATH,
  SF_TECH_WEEK_PATH,
  SITEMAP_PATH,
  STB_REQUEST_PATH,
  STB_REQUEST_SLUG_PATH,
  TENANT_ADMIN_PATH,
  TENANT_ADMIN_PAYMENTS_PATH,
  TENANT_ADMIN_SUMMARIES_PATH,
  TENANT_ADMIN_SUMMARY_DETAIL_PATH,
  TENANT_ADMIN_BILLING_PATH,
  TENANT_ADMIN_TEAM_PATH,
  TENANT_ADMIN_INTEGRATIONS_PATH,
  TENANT_ADMIN_PLATFORM_FEE_PROPOSAL_SLUG_PATH,
  TENANT_ADMIN_BUILDINGS_PATH,
  TENANT_ADMIN_BUILDING_PATH,
  TENANT_ADMIN_BUILDING_TAB_PATH,
  TENANT_ADMIN_BUILDING_ACCESS_PATH_INSTRUCTIONS_PATH,
  TENANT_ADMIN_BUILDING_ACCESS_PATH_PREVIEW_PATH,
  TENANT_ADMIN_MOBILE_SUBSCRIPTION_DETAILS_PATH,
  TENANT_ADMIN_PLATFORM_FEE_PROPOSALS_PATH,
  TENANT_PAYMENT_METHODS_PATH,
  TENANT_ADMIN_PAYMENT_METHODS_PATH,
  TERMS_PATH,
  TESTIMONIALS_PATH,
  VENDOR_TEAM_PATH,
  VENDOR_PATH,
  GFP_PATH,
  TENANT_ONBOARDING_CHECKLIST_PATH,
  TENANT_EMPLOYEE_COMING_SOON_PATH,
  SERVICES_REQUEST_PATH,
  SLACK_INTEGRATION_INSTALLED_PATH,
  SLACK_OAUTH_CALLBACK_PATH,
  SLACK_USER_OAUTH_CALLBACK_PATH,
  LANDLORD_PATH,
  LANDLORD_DASHBOARD_PATH,
  LANDLORD_PAYMENTS_PATH,
  TECH_MANAGEMENT_PATH,
  CLEANING_PATH,
  RESTOCKING_PATH,
  PUBLIC_FURNITURE_PATH,
  AI_OFFICE_ASSISTANT_PATH,
  VENDOR_NETWORK_PATH,
  OFFICE_SEO_ASSISTANT_NYC_PATH,
  OFFICE_SEO_ASSISTANT_SF_PATH,
  OFFICE_SEO_CLEANING_NYC_PATH,
  OFFICE_SEO_CLEANING_SF_PATH,
  OFFICE_SEO_FURNITURE_NYC_PATH,
  OFFICE_SEO_FURNITURE_SF_PATH,
  OFFICE_SEO_INTERNET_NYC_PATH,
  OFFICE_SEO_INTERNET_SF_PATH,
  OFFICE_SEO_PANTRY_NYC_PATH,
  OFFICE_SEO_PANTRY_SF_PATH,
  OFFICE_SEO_COMPARISON_PATH,
  OFFICE_SEO_HUB_PATH,
  OFFICE_SEO_SERVICES_CITY_PATH,
  OFFICE_SEO_DEEP_CLEANING_SF_PATH,
  OFFICE_SEO_DEEP_CLEANING_NYC_PATH,
  OFFICE_SEO_CARPET_CLEANING_SF_PATH,
  OFFICE_SEO_CARPET_CLEANING_NYC_PATH,
  OFFICE_SEO_WINDOW_CLEANING_SF_PATH,
  OFFICE_SEO_WINDOW_CLEANING_NYC_PATH,
  OFFICE_SEO_GLASS_CLEANING_SF_PATH,
  OFFICE_SEO_GLASS_CLEANING_NYC_PATH,
  OFFICE_SEO_WASTE_RECYCLING_SF_PATH,
  OFFICE_SEO_WASTE_RECYCLING_NYC_PATH,
  OFFICE_SEO_PANTRY_INVENTORY_SF_PATH,
  OFFICE_SEO_PANTRY_INVENTORY_NYC_PATH,
  OFFICE_SEO_COFFEE_SERVICE_SF_PATH,
  OFFICE_SEO_COFFEE_SERVICE_NYC_PATH,
  OFFICE_SEO_WATER_SERVICE_SF_PATH,
  OFFICE_SEO_WATER_SERVICE_NYC_PATH,
  OFFICE_SEO_TEAM_LUNCH_SF_PATH,
  OFFICE_SEO_TEAM_LUNCH_NYC_PATH,
  OFFICE_SEO_BREAKFAST_CATERING_SF_PATH,
  OFFICE_SEO_BREAKFAST_CATERING_NYC_PATH,
  OFFICE_SEO_INDIVIDUAL_MEALS_SF_PATH,
  OFFICE_SEO_INDIVIDUAL_MEALS_NYC_PATH,
  OFFICE_SEO_AD_HOC_CATERING_SF_PATH,
  OFFICE_SEO_AD_HOC_CATERING_NYC_PATH,
  OFFICE_SEO_HAPPY_HOUR_SF_PATH,
  OFFICE_SEO_HAPPY_HOUR_NYC_PATH,
  OFFICE_SEO_CONFERENCE_ROOM_AV_SF_PATH,
  OFFICE_SEO_CONFERENCE_ROOM_AV_NYC_PATH,
  OFFICE_SEO_NETWORK_INSTALLATION_SF_PATH,
  OFFICE_SEO_NETWORK_INSTALLATION_NYC_PATH,
  OFFICE_SEO_NETWORK_MANAGEMENT_SF_PATH,
  OFFICE_SEO_NETWORK_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_CABLE_MANAGEMENT_SF_PATH,
  OFFICE_SEO_CABLE_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_ROOM_BOOKING_SF_PATH,
  OFFICE_SEO_ROOM_BOOKING_NYC_PATH,
  OFFICE_SEO_PRINTING_SETUP_SF_PATH,
  OFFICE_SEO_PRINTING_SETUP_NYC_PATH,
  OFFICE_SEO_INTERIOR_DESIGN_SF_PATH,
  OFFICE_SEO_INTERIOR_DESIGN_NYC_PATH,
  OFFICE_SEO_OFFICE_MURALS_SF_PATH,
  OFFICE_SEO_OFFICE_MURALS_NYC_PATH,
  OFFICE_SEO_OFFICE_PAINTING_SF_PATH,
  OFFICE_SEO_OFFICE_PAINTING_NYC_PATH,
  OFFICE_SEO_GLASS_FROSTING_SF_PATH,
  OFFICE_SEO_GLASS_FROSTING_NYC_PATH,
  OFFICE_SEO_OFFICE_SIGNAGE_SF_PATH,
  OFFICE_SEO_OFFICE_SIGNAGE_NYC_PATH,
  OFFICE_SEO_CARE_ROOM_SF_PATH,
  OFFICE_SEO_CARE_ROOM_NYC_PATH,
  OFFICE_SEO_FURNITURE_ASSEMBLY_SF_PATH,
  OFFICE_SEO_FURNITURE_ASSEMBLY_NYC_PATH,
  OFFICE_SEO_LAYOUT_CHANGE_SF_PATH,
  OFFICE_SEO_LAYOUT_CHANGE_NYC_PATH,
  OFFICE_SEO_OFFICE_PLANTS_SF_PATH,
  OFFICE_SEO_OFFICE_PLANTS_NYC_PATH,
  OFFICE_SEO_KEYLESS_ACCESS_SF_PATH,
  OFFICE_SEO_KEYLESS_ACCESS_NYC_PATH,
  OFFICE_SEO_ALARM_SYSTEMS_SF_PATH,
  OFFICE_SEO_ALARM_SYSTEMS_NYC_PATH,
  OFFICE_SEO_SECURITY_CAMERAS_SF_PATH,
  OFFICE_SEO_SECURITY_CAMERAS_NYC_PATH,
  OFFICE_SEO_KEYPADS_SF_PATH,
  OFFICE_SEO_KEYPADS_NYC_PATH,
  OFFICE_SEO_LOCKBOXES_SF_PATH,
  OFFICE_SEO_LOCKBOXES_NYC_PATH,
  OFFICE_SEO_VISITOR_MANAGEMENT_SF_PATH,
  OFFICE_SEO_VISITOR_MANAGEMENT_NYC_PATH,
  OFFICE_SEO_BUSINESS_INSURANCE_SF_PATH,
  OFFICE_SEO_BUSINESS_INSURANCE_NYC_PATH,
  OFFICE_SEO_ELECTRICAL_SERVICES_SF_PATH,
  OFFICE_SEO_ELECTRICAL_SERVICES_NYC_PATH,
  OFFICE_SEO_HVAC_SF_PATH,
  OFFICE_SEO_HVAC_NYC_PATH,
  OFFICE_SEO_PLUMBING_SF_PATH,
  OFFICE_SEO_PLUMBING_NYC_PATH,
  OFFICE_SEO_PEST_CONTROL_SF_PATH,
  OFFICE_SEO_PEST_CONTROL_NYC_PATH,
  OFFICE_SEO_OFFICE_MOVING_SF_PATH,
  OFFICE_SEO_OFFICE_MOVING_NYC_PATH,
  OFFICE_SEO_MOUNTING_INSTALLATION_SF_PATH,
  OFFICE_SEO_MOUNTING_INSTALLATION_NYC_PATH,
  TENANT_ADMIN_BUILDING_INTERNET_PLANS_PATH,
  TENANT_ADMIN_BUILDING_INTERNET_PLANS_CHECKOUT_PATH
] as const;

export const REDIRECTS = [];

export type Path = (typeof PATHS)[number];
